import { useState } from 'react';
import WrapperLineComponent from '@/components/shared/charts/LineComponent/wrapper-line-component';
import { Box, Button, Typography } from '@mui/material';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const JugadoresMercadoGraphicComponent = ({ player }) => {
    if (!player?.marketValues?.length) return null;

    const [filter, setFilter] = useState('7 días');

    // Filtra datos según el filtro seleccionado y los ordena ascendentemente
    const getFilteredMarketValues = () => {
        let marketValues = [...player.marketValues].sort((a, b) => new Date(a.created) - new Date(b.created));
        return filter === '7 días' ? marketValues.slice(-7) : marketValues.slice(-30);
    };

    const filteredMarketValues = getFilteredMarketValues();

    const options = {
        plugins: {
            legend: {
                display: false, // 🔹 Esto oculta la leyenda completamente
            },
        },
    };

    const data = {
        labels: filteredMarketValues.map((value) => value.created),
        datasets: [
            {
                label: '',
                data: filteredMarketValues.map((value) => value.marketValue),
                fill: false,
                borderColor: '#36A2EB',
                backgroundColor: '#36A2EB',
                borderWidth: 2,
                pointRadius: 4,
                pointBackgroundColor: '#36A2EB',
            },
        ],
    };

    return (
        <CustomSectionWrapper title="Subidas y bajadas de mercado (Gráfico)" color="accent2">
            <Box sx={{ display: 'flex', gap: '10px' }} mt={1} mb={1}>
                {['7 días', '30 días'].map((option) => (
                    <Button
                        key={option}
                        variant={filter === option ? 'contained' : 'outlined'}
                        color="primary"
                        onClick={() => setFilter(option)}
                        sx={{ height: '30px', padding: '0 10px' }}
                    >
                        <Typography
                            fontSize={14}
                            component="span"
                            color={filter === option ? 'white' : 'primary'}
                        >
                            {option}
                        </Typography>
                    </Button>
                ))}
            </Box>
            <WrapperLineComponent data={data} options={options} />
        </CustomSectionWrapper>
    );
};

export default JugadoresMercadoGraphicComponent;
